export default __webpack_public_path__ + "static/media/house1.95d15ef6.jpeg";